import React from 'react';
import { Leaf } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  showIcon?: boolean;
  scrollTo?: string;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  showIcon = true,
  scrollTo,
  href
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (scrollTo) {
      e.preventDefault();
      const el = document.getElementById(scrollTo);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - 20;
        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      }
    }
  };
  if (href) {
    const handleBuyClick = () => {
      trackAddToCart();
    };
    return <a href={href} target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className={`inline-flex items-center justify-center px-10 py-5 text-xl font-bold text-white transition-all duration-300 rounded-full shadow-lg bg-sage-600 hover:bg-sage-700 hover:shadow-xl hover:-translate-y-1 cursor-pointer ${className}`} data-id="element-11">
        {showIcon && <Leaf className="w-6 h-6 mr-2" data-id="element-12" />}
        {children}
      </a>;
  }
  return <button type="button" onClick={handleClick} className={`inline-flex items-center justify-center px-10 py-5 text-xl font-bold text-white transition-all duration-300 rounded-full shadow-lg bg-sage-600 hover:bg-sage-700 hover:shadow-xl hover:-translate-y-1 cursor-pointer ${className}`} data-id="element-13">
      {showIcon && <Leaf className="w-6 h-6 mr-2" data-id="element-14" />}
      {children}
    </button>;
}